define(['app/modules/utilities', 'rangeslider.js'], (Utils) => {
  const SKILLS_FIELDS_NAMES = ['id', '_destroy', 'exists', 'theme_id', 'name', 'level'];
  const DEFAULT_SLIDER_VALUE = 50;

  class EmploytmentHistoryItem {
    constructor({ el = document, resourceName }) {
      this.themes = window.themes;
      this.subThemes = window.subThemes;
      this.skills = window.skills;
      this.skillsFamily = window.skillsFamily;

      this.resourceName = resourceName;

      this.$el = $(el);
      this.$themesSelect = this.$el.find('.js-theme-select');
      this.$subThemesSelect = this.$el.find('.js-subthemes-select');
      this.$skillsSelect = this.$el.find('.js-skills-select');
      this.index = this.$el.data('index');

      this.skillTemplate = 'js-skill-template';
      this.skillItemSelect = '.js-skill-container';

      this.$subThemesContainer = this.$el.find('.js-subthemes');
      this.$skillsContainer = this.$el.find('.js-skills');
      this.$skillsList = this.$el.find('.js-skills-list');

      this.toggleShowSubThemes = this.toggleShowSubThemes.bind(this);
      this.toggleShowSkills = this.toggleShowSkills.bind(this);
      this.addSkill = this.addSkill.bind(this);
      this.removeSkill = this.removeSkill.bind(this);

      this.renderSkills();
      this.bindEvents();
    }

    renderSkills() {
      const skills = this.$skillsSelect.data('skills');
      const subThemeId = +this.$subThemesSelect.val();

      this.toggleShowSubThemes(null, false, subThemeId);

      if (skills && skills.focuses.length) {
        skills.focuses.forEach(skill => this.renderSkill(skill));
      }
    }

    bindEvents() {
      this.$themesSelect.on('change', this.toggleShowSubThemes);
      this.$subThemesSelect.on('change', this.toggleShowSkills);
      this.$skillsSelect.on('change', this.addSkill);
    }

    toggleShowSubThemes(event, shouldDeleteSelected = true, value = null) {
      const themeId = this.$themesSelect.val();
      const subThemes = this.getById(this.subThemes, [Number(themeId)]);
      const sortedSubThemes = Utils.sortAlphabeticallyByKey(subThemes);
      if (shouldDeleteSelected) this.deleteSelectedSkills();
      if (themeId) {
        this.updateSelect({
          $container: this.$subThemesContainer,
          $select: this.$subThemesSelect,
          options: sortedSubThemes,
          value,
        });

        if (value) {
          const skillsGroups = this.getSkillsGroups({ id: value });
          this.updateSelect({
            $container: this.$skillsContainer,
            $select: this.$skillsSelect,
            skillsGroups
          });
        }
      } else {
        this.$subThemesContainer.addClass('dn');
      }
    }

    toggleShowSkills(event) {
      const id = +event.target.value;
      const mainThemeId = +this.$themesSelect.val();
      const skills = this.getById(this.skills, [id, mainThemeId]);
      const skillsGroups = this.getSkillsGroups({ id });

      this.deleteSelectedSkills();
      if (id) {
        this.updateSelect({
          $container: this.$skillsContainer,
          $select: this.$skillsSelect,
          options: skills,
          skillsGroups,
        });
      }
    }

    deleteSelectedSkills() {
      this.$skillsContainer.addClass('dn');

      this.$skillsList.find(`${this.skillItemSelect} .js-input-_destroy`).val(true);

      this.$skillsList.find(this.skillItemSelect).addClass('dn');
    }

    getById(skills, ids) {
      return skills.filter(skill => skill.parents.filter(parent => ids.indexOf(parent.id) !== -1).length);
    }

    getSkillsGroups(params) {
      const skillsGroups = [];

      const skillsFamilies = this.skillsFamily.filter(item => item.parents.find(parent => parent.id === +params.id));

      const allSkills = [];
      skillsFamilies.forEach((group) => {
        skillsGroups[group.id] = [];
        this.skills.forEach((item) => {
          if (item.parents.find(parent => parent.id === group.id) && !allSkills.includes(item.id)) {
            skillsGroups[group.id].push(item);
            allSkills.push(item.id);
          }
        });
      });

      return skillsGroups;
    }

    updateSelect({
      $container, $select, options, value, skillsGroups,
    }) {
      if (options) {
        const emptyOption = [Utils.createElement('option')];
        const $options = emptyOption.concat(options.map(option => Utils.createElement('option', { value: option.id }, option.name)));

        $select
          .empty()
          .append($options)
          .trigger('chosen:updated');
      }

      if (skillsGroups && skillsGroups.length) {
        Object.keys(skillsGroups).forEach((key) => {
          const optgroupEl = document.createElement('optgroup');
          const group = this.skillsFamily.find(preference => preference.id === +key);
          optgroupEl.label = group.name;
          const fragmentGroup = this.createOptions({ options: skillsGroups[key], parent: optgroupEl });
          $select
            .append(fragmentGroup)
            .trigger('chosen:updated');
        });
      }

      if (value) {
        $select.val(value).trigger('chosen:updated');
      }

      $container.removeClass('dn');
    }

    createOptions(params) {
      const fragment = params.parent || document.createDocumentFragment();

      params.options.forEach((option) => {
        const optionEl = document.createElement('option');
        optionEl.value = option.id;
        optionEl.text = option.name;
        fragment.appendChild(optionEl);
      });

      return fragment;
    }

    addSkill(event) {
      const id = +event.target.value;
      const skill = this.skills.find(skill => skill.id === id);

      this.renderSkill(skill);
    }

    toggleSkillsSelect(id, disabled) {
      this.$skillsSelect.find(`option[value=${id}]`).attr('disabled', disabled);
      this.$skillsSelect.val('').trigger('chosen:updated');
    }

    renderSkill(skill) {
      const template = $(`.${this.skillTemplate}`).clone();
      const data = {
        id: skill.id && skill.theme_id ? skill.id : null,
        theme_id: skill.theme_id ? skill.theme_id : skill.id,
        level: 'focus',
        name: skill.name,
        _destroy: false,
        exists: Boolean(skill.id && skill.theme_id),
      };

      const $inputs = SKILLS_FIELDS_NAMES.map((name) => {
        const value = data[name];
        return Utils.createElement('input', {
          class: `js-input-${name}`,
          type: 'hidden',
          name: this.getInputName(name, this.index),
          value,
          'data-id': skill.id,
        });
      });

      template
        .removeClass(`${this.skillTemplate} dn`)
        .find('.js-name')
        .html(skill.name);
      template.find('.js-skill-button').on('click', this.removeSkill);

      template
        .find('.js-range-slider')
        .attr({
          name: this.getInputName('experience', this.index),
        })
        .val(skill.experience || DEFAULT_SLIDER_VALUE);

      template.append($inputs);
      this.$skillsList.append(template);
      this.initRangeSlider(template);
      this.toggleSkillsSelect(skill.theme_id ? skill.theme_id : skill.id, true);
    }

    initRangeSlider($el) {
      $el.find('[type="range"]').rangeslider({
        polyfill: false,
        onInit() {
          const value = this.$element.val();
          const $label = Utils.createElement(
            'div',
            { class: 'rangeslider__label js-range-label' },
            value,
          );

          $label.css('left', this.position);
          this.$range.append($label);
        },
        onSlide(position, value) {
          const $label = this.$range.children('.js-range-label');

          $label.css('left', position).html(value);
        },
      });
    }

    getInputName(name, index) {
      return `${this.resourceName}[experiences_attributes][${index}][skills_attributes][][${name}]`;
    }

    addHtml(data) {}

    toggleSkill($option, $skillItem, experience) {}

    removeSkill(event) {
      const $target = $(event.currentTarget);
      const $parent = $target.parents(this.skillItemSelect);
      const id = $parent.find('.js-input-theme_id').val();

      this.toggleSkillsSelect(id, false);

      $parent.addClass('dn');
      $parent.find('.js-input-_destroy').val(true);
    }
  }

  return EmploytmentHistoryItem;
});
